import { render, staticRenderFns } from "./OfferIap.vue?vue&type=template&id=1367d4be&scoped=true"
import script from "./OfferIap.vue?vue&type=script&lang=js"
export * from "./OfferIap.vue?vue&type=script&lang=js"
import style0 from "./OfferIap.vue?vue&type=style&index=0&id=1367d4be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1367d4be",
  null
  
)

export default component.exports